var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.6107C21.9036 28.6107 27.5 22.9705 27.5 16.0129C27.5 9.05528 21.9036 3.41504 15 3.41504C8.09644 3.41504 2.5 9.05528 2.5 16.0129C2.5 22.9705 8.09644 28.6107 15 28.6107Z",
    fill: "#FF3333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12.2335L11.25 19.7922M11.25 12.2335L18.75 19.7922M27.5 16.0129C27.5 22.9705 21.9036 28.6107 15 28.6107C8.09644 28.6107 2.5 22.9705 2.5 16.0129C2.5 9.05528 8.09644 3.41504 15 3.41504C21.9036 3.41504 27.5 9.05528 27.5 16.0129Z",
    stroke: "#F6F8F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ebe219399af739d33ab5d819a2b4b984.svg";
export { ForwardRef as ReactComponent };